// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"443":"about","525":"articles","535":"login"}[chunkId] || chunkId) + "." + {"443":"b529260b","525":"50d9e7ea","535":"8dea7ac7","739":"d6c7b42f"}[chunkId] + ".js";
};